import { Skeleton } from "antd";
import styles from "../../../styles/Components/new-dashboard/DashboardLoaders.module.css";

function TopCommunityBotsLoader() {
  return (
    <>
      <Skeleton active paragraph={{ rows: 0 }} />
      <div className={styles.topBotsLoader}>
        {Array.from(Array(3).keys()).map((_, i) => (
          <Skeleton.Node active key={i} />
        ))}
      </div>
    </>
  );
}

export default TopCommunityBotsLoader;
